import { srmAsset } from '../assets';
import type { SrmOverview } from '../types';

/** AI-SRM 一级页（/product/ai-srm）全部文案与配图 */
export const overview: SrmOverview = {
  hero: {
    background: {
      url: srmAsset('overview/hero.webp'),
      alt: 'AI SRM采购业务蓝色场景背景，采购单据、包裹与智能手部托举业务人员'
    },
    titleLines: ['智慧采购，', '不止上线，更要持续生长'],
    lead: '从流程在线走向价值创造，让每一笔采购更省、更稳、更有价值。',
    features: [
      { title: '智能治理', desc: '数据可视，决策有据' },
      { title: '业务协同', desc: '跨部门高效联动' },
      { title: '合规内控', desc: '规则前置，全程可审计' },
      { title: '智慧演进', desc: '业务不中断，持续生长' }
    ],
    cta: '立即咨询'
  },
  challenge: {
    title: '采购系统上线了，为什么难题还在？',
    desc: '流程在线只是起点。规模型组织更需要统一资源、贯通数据、前置风险，并保留业务灵活性。',
    photo: {
      url: srmAsset('overview/problem.webp'),
      alt: '广阔的自动化供应链车间中，采购与管理人员以背影围绕数据进行讨论'
    },
    photoCaption: {
      label: '从真实业务出发',
      text: '让采购、业务与管理者看见同一张图'
    },
    items: [
      { num: '01 / 协同', title: '各自采购，议价优势被摊薄', desc: '同品不同价，规模没有转化为采购优势。' },
      { num: '02 / 全链路', title: '只管招标，前后仍是断点', desc: '需求、合同、履约、结算无法一线贯通。' },
      { num: '03 / 合规', title: '制度靠人记，风险发现太晚', desc: '控制点没有进入流程，审计取证成本高。' },
      { num: '04 / 品类', title: '一物多名，数据难以复用', desc: '分类与编码不一，业务与分析失去基础。' },
      { num: '05 / 供应商', title: '资源分散，优劣风险看不清', desc: '缺少统一档案、绩效与风险视图。' },
      { num: '06 / 演进', title: '旧系统不敢动，新能力上线慢', desc: '既要业务不停，也要平台持续升级。' }
    ]
  },
  blueprint: {
    title: '智慧供应链：重协同、全覆盖、智能化',
    desc: '理想的智慧采购平台，不只是把流程搬到线上，而是以统一治理连接完整业务链，以智能能力支撑组织持续演进。',
    image: {
      url: srmAsset('overview/blueprint.webp'),
      alt: '智慧供应链多用户协同、全链路覆盖与智能化场景示意图'
    },
    governanceLabel: '治理原则',
    governanceRules: [
      { num: '01', title: '管理与自主', desc: '总部统一规则，各组织灵活执行' },
      { num: '02', title: '合规与效率', desc: '规则嵌入流程，全程自动留痕' },
      { num: '03', title: '存量与演进', desc: '平滑接入现有系统，持续扩展' }
    ],
    chainLabel: '采购全链路',
    chainTitle: ['从需求到结算', '一条业务链贯通到底'],
    chainSteps: ['寻源', '谈判', '合同', '供应商管理', '订单', '履约', '结算'],
    outcomesLabel: '可交付价值',
    outcomes: [
      { num: '01', title: '统一看得见', desc: '组织、品类与供应商形成一张图' },
      { num: '02', title: '过程管得住', desc: '规则前置，风险在流程中拦截' },
      { num: '03', title: '业务跑得好', desc: '智能交互高效，能力持续演进' }
    ],
    scenesLabel: '六大智慧场景',
    foundation: {
      label: '统一能力底座',
      title: '数智化采购平台',
      tags: ['统一数据', '统一规则', '人工智能', '大数据', '微服务', '云与业务中台']
    }
  },
  capability: {
    title: '六大智慧场景，让AI真正进入采购业务',
    desc: '智能能力进入真实采购环节，在流程中完成识别、推荐、执行、预警与分析。'
  },
  cases: {
    title: '复杂组织，也能走出清晰的演进路径',
    desc: '多组织、多业态、多系统并存，仍能统一治理、平滑推广。',
    items: [
      {
        name: '白贝壳 babycare',
        image: {
          url: srmAsset('overview/case/babycare.webp'),
          alt: '白贝壳 babycare 母婴产品研发、仓储与智能履约场景'
        },
        href: 'https://www.terminus.io/article-detail/news/2073004'
      },
      {
        name: '晶科能源',
        image: { url: srmAsset('overview/case/jinko-solar.webp'), alt: '晶科能源的风电与光伏清洁能源场景' },
        href: 'https://www.terminus.io/case-detail/16083'
      },
      {
        name: '山东海化',
        image: { url: srmAsset('overview/case/shandong-haihua.webp'), alt: '山东海化的石化生产基地场景' },
        href: 'https://www.terminus.io/case-detail/2010001'
      }
    ]
  },
  cta: {
    title: '让采购，成为组织看得见的价值',
    desc: '告诉我们您的采购场景与所处阶段，我们将为您设计一条可集成、可试点、可演进的建设路径。',
    primary: '预约演示',
    secondary: '更多相关内容'
  }
};
